<template>
<div class="body1">
 <el-form  :model="form1" :rules="rules" ref="form1" label-width="100px" class="demo-ruleForm">
  <el-form-item label="企业名称" prop="eName">
    <el-input v-model="form1.eName"></el-input>
  </el-form-item>
   <el-form-item label="统一社会信用代码" prop="eCode">
    <el-input v-model="form1.eCode"></el-input>
  </el-form-item>
   <el-form-item label="注册地址"  prop="eAddr">
    <el-input v-model="form1.eAddr"></el-input>
  </el-form-item>
   <el-form-item label="法人代表姓名" prop="jperson">
    <el-input v-model="form1.jperson"></el-input>
  </el-form-item>
   <el-form-item label="手机号码" prop="tel">
    <el-input v-model="form1.tel"></el-input>
  </el-form-item>
   <el-form-item label="电子邮箱" prop="mail">
    <el-input v-model="form1.mail"></el-input>
  </el-form-item>
      <el-form-item label="经营期限" required>
    <el-col :span="11">
      <el-form-item prop="managementTimestart">
        <el-date-picker type="date" placeholder="经营起始日" v-model="form1.managementTimestart"
                        style="width: 200px;margin-left: -140px;" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
    </el-col>
  </el-form-item>
   <el-form-item label="" required>
    <el-col :span="11">
      <el-form-item prop="managementTimeend">
        <el-date-picker type="date" placeholder="经营到期日" v-model="form1.managementTimeend"
                        style="width: 200px;margin-left: -140px;" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" ></el-date-picker>
      </el-form-item>
    </el-col>
  </el-form-item>
   <el-form-item label="经营范围" prop="managementScope">
    <el-input type="textarea"  rows="10" cols="20" v-model="form1.managementScope"></el-input>
  </el-form-item>
   <el-form-item label="登记机关"  prop="registerDept">
    <el-input v-model="form1.registerDept"></el-input>
  </el-form-item>

   <el-form-item label="评级类型"  prop="gradeType">
    <el-input  maxlength="10"  v-model="form1.gradeType"></el-input>
  </el-form-item>
   <el-form-item label="信用等级"  prop="creditRegistration">
    <el-input v-model="form1.creditRegistration"></el-input>
  </el-form-item>
   <el-form-item label="证书编号"  prop="certificateNumber">
    <el-input v-model="form1.certificateNumber"></el-input>
  </el-form-item>
   <el-form-item label="评价日期" required>
    <el-col :span="11">
      <el-form-item prop="appraiseDate">
        <el-date-picker
      v-model="form1.appraiseDate"
      type="date"
      placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width: 200px;margin-left: -140px;" >
    </el-date-picker>
      </el-form-item>
    </el-col>
  </el-form-item>
   <el-form-item label="有效期至" required>
    <el-col :span="11">
      <el-form-item prop="term">
        <el-date-picker
      v-model="form1.term"
      type="date"
      placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" style="width: 200px;margin-left: -140px;">
    </el-date-picker>
      </el-form-item>
    </el-col>
  </el-form-item>
   <el-form-item label="评价机构名称" prop="organization">
    <el-input v-model="form1.organization"></el-input>
  </el-form-item>
  <el-form-item>
    <el-button type="primary"  @click="checkForm('form1')"  @keyup.enter.native="checkForm('form1')">保存并提交</el-button>
  </el-form-item>
</el-form>
   </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataPost } from '@/api/index'
export default {
  name: 'disclosuresRelease',
  data () {
    var eName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入企业名称'))
      } else {
        callback()
      }
    }
    var eCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('统一社会信用代码不能为空'))
      } else {
        const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的统一社会信用代码'))
        }
      }
    }
    var eAddr = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入注册地址'))
      } else {
        callback()
      }
    }
    var jperson = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入法定代表人'))
      } else {
        callback()
      }
    }
    var mail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      } else {
        const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的邮箱'))
        }
      }
    }
    var registerDept = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入登记机关'))
      } else {
        callback()
      }
    }
    var managementScope = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入经营范围'))
      } else {
        callback()
      }
    }
    var certificateNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入证书编号'))
      } else {
        callback()
      }
    }
    var organization = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入评级机构'))
      } else {
        callback()
      }
    }
    var term = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择时间'))
      } else {
        callback()
      }
    }
    var appraiseDate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择时间'))
      } else {
        callback()
      }
    }
    var managementTimestart = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择时间'))
      } else {
        if (value > this.form1.managementTimeend) {
          callback(new Error('请选择正确时间'))
        } else { callback() }
      }
    }
    var managementTimeend = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选择时间'))
      } else {
        if (value < this.form1.managementTimestart) {
          callback(new Error('请选择正确时间'))
        } else { callback() }
      }
    }
    var creditRegistration = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入信用等级'))
      } else {
        callback()
      }
    }
    var gradeType = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入评级类型'))
      } else {
        callback()
      }
    }
    var tel = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号码不能为空'))
      } else {
        const reg = /^1[3456789]\d{9}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号码'))
        }
      }
    }
    return {
      form1: {
        eName: '',
        eCode: '',
        gradeType: '',
        creditRegistration: '',
        certificateNumber: '',
        jperson: '',
        tel: '',
        mail: '',
        createTime: '',
        managementTime: '',
        registerDept: '',
        eAddr: '',
        managementScope: '',
        certificate: '',
        appraiseDate: '',
        term: '',
        organization: ''
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      rules: {
        eName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { validator: eName, trigger: 'blur' },

          { max: 30, message: '请勿输入过长名称', trigger: ['blur', 'change'] }
        ],
        eCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { validator: eCode, trigger: 'blur' },

          { min: 18, max: 18, message: '请输入正确组织机构代码', trigger: ['blur', 'change'] }
        ],
        jperson: [
          { required: true, message: '请输入法定代表人', trigger: 'blur' },
          { validator: jperson, trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: tel, trigger: 'blur' }
        ],
        mail: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { validator: mail, trigger: 'blur' }
        ],

        registerDept: [
          { required: true, message: '请输入登记机关', trigger: 'blur' },
          { validator: registerDept, trigger: 'blur' }

        ],
        eAddr: [
          { required: true, message: '请输入注册地址', trigger: 'blur' },
          { validator: eAddr, trigger: 'blur' }
        ],
        managementScope: [
          { required: true, message: '请输入经营范围', trigger: 'blur' },
          { validator: managementScope, trigger: 'blur' }
        ],
        certificateNumber: [
          { required: true, message: '请输入证书编号', trigger: 'blur' },
          { validator: certificateNumber, trigger: 'blur' }
        ],
        creditRegistration: [
          { required: true, message: '请输入信用等级', trigger: 'blur' },
          { validator: creditRegistration, trigger: 'blur' }
        ],
        organization: [
          { required: true, message: '请输入评价机构名称', trigger: 'blur' },
          { validator: organization, trigger: 'blur' }
        ],
        gradeType: [
          { required: true, message: '请输入评级类型', trigger: 'blur' },
          { min: 1, max: 20, message: '仅限20个字符', trigger: 'blur' },
          { validator: gradeType, trigger: 'blur' }
        ],
        term: [
          { required: true, message: '请选择时间', trigger: 'blur' },
          { validator: term, trigger: 'blur' }
        ],
        appraiseDate: [
          { required: true, message: '请选择时间', trigger: 'blur' },
          { validator: appraiseDate, trigger: 'blur' }
        ],
        managementTimeend: [
          { required: true, message: '请选择经营起始日', trigger: 'blur' },
          { validator: managementTimeend, trigger: 'blur' }
        ],
        managementTimestart: [
          { required: true, message: '请选择经营到期日', trigger: 'blur' },
          { validator: managementTimestart, trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    submitForm (event) {
      var params = new URLSearchParams()
      let that = this
      let reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
      let regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      params.append('eName', this.form1.eName)
      params.append('eCode', this.form1.eCode)
      params.append('eAddr', this.form1.eAddr)
      params.append('jperson', this.form1.jperson)
      params.append('tel', this.form1.tel)
      params.append('mail', this.form1.mail)
      params.append('managementTimestart', this.form1.managementTimestart)
      params.append('managementTimeend', this.form1.managementTimeend)
      params.append('managementScope', this.form1.managementScope)
      params.append('registerDept', this.form1.registerDept)
      params.append('gradeType', this.form1.gradeType)
      params.append('creditRegistration', this.form1.creditRegistration)
      params.append('certificateNumber', this.form1.certificateNumber)
      params.append('appraiseDate', this.form1.appraiseDate)
      params.append('term', this.form1.term)
      params.append('organization', this.form1.organization)
      if (that.form1.eName === '') { alert('请输入企业名称') } else if (that.form1.eCode === '') { alert('请输入企业机构代码') } else if (!reg.test(that.form1.eCode)) { alert('请确认正确企业机构代码格式') } else if (that.form1.eAddr === '') { alert('请确认注册地址') } else if (that.form1.jperson === '') { alert('请输入法人姓名') } else if (that.form1.tel === '') { alert('请输入电话号码') } else if (that.form1.mail === '') { alert('请输入邮箱') } else if (!regEmail.test(that.form1.mail)) { alert('请确认正确的邮箱') } else if (that.form1.managementTimestart === '') { alert('请选择登记日期') } else if (that.form1.managementTimeend === '') { alert('请选择截至日期') } else if (that.form1.managementTimeend <= that.form1.managementTimestart) { alert('营业到期日不能小于营业起始日') } else if (that.form1.managementScope === '') { alert('请输入经营范围') } else if (that.form1.registerDept === '') { alert('请输入登记机构') } else if (that.form1.appraiseDate === '') { alert('请选择评级日期') } else if (that.form1.term === '') { alert('请选择截止日期') } else if (that.form1.organization === '') { alert('请输入评价机构名称') } else {
        dataPost(rootPathssb.rootPath + '/jg/add', params).then(function (response) {
          if (response.data.result === 1) {
            alert('保存成功')
            that.$router.push({path: '/disclosureshome'})
            console.log('cg')
          };

          console.log(response.data)
        }).catch(function (error) {
          console.log(error); console.log(2222222222)
        })
      }
    },
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    }
  }
}
</script>

<style >
.body1{
  width:600px;
  margin: 0 auto;
}
 .body1 .el-form-item__label{
  width: 140px !important;
}
.body1 .el-form-item__content{
   margin-left: 140px !important;
 }

</style>



// WEBPACK FOOTER //
// src/components/disclosures/disclosuresRelease.vue